import { EventEmitter, Service } from '@angular/core';

@Service()
export class CommunicationService {

  maximizedChange = new EventEmitter<boolean>();

  setMaximizedMode(maximized: boolean) {
    this.maximizedChange.emit(maximized);
  }
}
